import React from 'react';
import PropTypes from 'prop-types';
import { IconWrapper, ButtonActionItem, AnchorActionItem } from './styles';
export const ALLOWED_ELEMENTS = ['button', 'a'];
const ActionItemComponents = {
    a: AnchorActionItem,
    button: ButtonActionItem,
};
const SideMenuActionItem = ({ 'data-qa-anchor': dataQaAnchor = '', icon, children, active, className, onClick, element = 'a', disabled, }) => {
    const ActionItemContainer = ActionItemComponents[element];
    return (React.createElement(ActionItemContainer, { "data-qa-anchor": dataQaAnchor, className: className, active: active, disabled: disabled, onClick: onClick },
        icon && React.createElement(IconWrapper, { active: active }, icon),
        React.createElement("span", { className: "actionItemChild" }, children)));
};
SideMenuActionItem.propTypes = {
    'data-qa-anchor': PropTypes.string,
    element: PropTypes.oneOf(ALLOWED_ELEMENTS),
    icon: PropTypes.node,
    children: PropTypes.node,
    active: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
};
export default SideMenuActionItem;
//# sourceMappingURL=index.js.map